import { useLayoutEffect, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { DataService } from '../config/dataService/dataService_yerbis';
import { SpinerCustomStyle } from '../container/bilgiSayfalari/style';
import { Spin } from 'antd';
import { MenuDataRead } from '../redux/menuCalismaSayilari/actionCreator';

import {
  UilUser,
  UilFolder,
  UilFolderPlus,
  UilFolderCheck,
  UilFolderExclamation,
  UilFolderLock,
  UilFolderInfo,
  UilFolderDownload,
  UilUserCheck,
  UilRefresh,
  UilCheckCircle,
  UilUsersAlt,
  UilUserArrows,
  UilArrowFromRight,
  UilBuilding,
  UilBriefcase,
  UilHardHat,
  UilMegaphone,
  UilCommentAltEdit,
  UilServerConnection,
} from '@iconscout/react-unicons';
import { TopMenuStyle } from './Style';
import Can from '../components/can/can';
import {
  MUHENDIS,
  FIRMA,
  SUBE_MUDURU,
  KAMU_MUHENDISI,
  KOMISYON_UYESI,
  KOMISYON_YEDEK_UYESI,
  UYGULAMA_YONETICISI,
  BAKANLIK_DAIRE_BASKANI,
  GENEL_MUDUR,
  GENEL_MUDUR_YARDIMCISI,
  IL_MUDURU,
  IL_MUDUR_YARDIMCISI,
  IL_SUBE_MUDURU,
} from '../constants/roleConstant';
import YerbisConstants from '../constants/yerbisConstants';
import NotificationHelper from '../utility/notificationHelper';
import ProjeDurumDegistir from './ProjeDurumDegistir';
import KullaniciTayinIslemi from './KullaniciTayinIslemi';
import ProjeYonetimi from './ProjeYonetimi';
import ReferansNoOlustur from './ReferansNoOlustur';

function TopMenu() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const path = '/admin';
  const { t } = useTranslation();
  const { user, hasRole, hasRoles, userDetail } = useAuth();
  const [projeDurumDegistirVisible, setProjeDurumDegistirVisible] = useState(false);
  const [projeYonetimiVisible, setProjeYonetimiVisible] = useState(false);
  const [referansNoOlusturVisible, setReferansNoOlusturVisible] = useState(false);

  useLayoutEffect(() => {
    dispatch(MenuDataRead());
    const active = document.querySelector('.ninjadash-top-menu a.active');
    const activeDefault = () => {
      const megaMenu = active.closest('.megaMenu-wrapper');
      const hasSubMenuLeft = active.closest('.has-subMenu-left');
      if (!megaMenu) {
        active.closest('ul').previousSibling.classList.add('active');
        if (hasSubMenuLeft) hasSubMenuLeft.closest('ul').previousSibling.classList.add('active');
      } else {
        active.closest('.megaMenu-wrapper').previousSibling.classList.add('active');
      }
    };
    window.addEventListener('load', active && activeDefault);
    return () => window.removeEventListener('load', activeDefault);
  }, []);

  useLayoutEffect(() => {
    const operations = async () => {
      setLoading(true);
      console.log('userDetail', userDetail);
      if (!userDetail) {
        dispatch(MenuDataRead());
      }
      setLoading(false);
    };
    operations();
  }, [userDetail]);

  const { menuData } = useSelector((state) => {
    return {
      menuData: state.menuProje.menuData,
    };
  }, shallowEqual);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'reduxMenuItemUpdate') {
        dispatch(MenuDataRead());
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch]);

  const addParentActive = (event) => {
    document.querySelectorAll('.parent').forEach((element) => {
      element.classList.remove('active');
    });

    localStorage.removeItem('filters');
    const hasSubMenuLeft = event.currentTarget.closest('.has-subMenu-left');
    const megaMenu = event.currentTarget.closest('.megaMenu-wrapper');
    if (!megaMenu) {
      event.currentTarget.closest('ul').previousSibling.classList.add('active');
      if (hasSubMenuLeft) hasSubMenuLeft.closest('ul').previousSibling.classList.add('active');
    } else {
      event.currentTarget.closest('.megaMenu-wrapper').previousSibling.classList.add('active');
    }
  };

  const fetchAndDownloadExcel = async () => {
    setLoading(true);
    try {
      const response = await DataService.getBlob(
        `${process.env.REACT_APP_PERSONEL_PROJE_DURUMLARI_EXCEL_EXPORT_ENDPOINT}`,
      );

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = downloadUrl;
      link.setAttribute('download', 'PersonelProjeDurumlari.xlsx');

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(downloadUrl);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      NotificationHelper.setErrorNotification(t('processUnexpectedError'));
    }
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  // Modal'ı kapama işlevi
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const isSubeMuduru = user.userGroups.some((i) => i.userGroupId === SUBE_MUDURU);
  const daireBaskaniOrUygulamaYoneticis = user.userGroups.some(
    (i) => i.userGroupId === BAKANLIK_DAIRE_BASKANI || i.userGroupId === UYGULAMA_YONETICISI,
  );

  const bakanlikSubeMuduru =
    isSubeMuduru && user.organizationId === YerbisConstants.NodeIds.Bakanlik && !daireBaskaniOrUygulamaYoneticis;

  useEffect(() => {
    // Sadece tanımlar menüsü için uygula
    const handleMouseEnter = (e) => {
      const subMenu = e.currentTarget.querySelector('.subMenu');
      if (!subMenu) return;
      const rect = subMenu.getBoundingClientRect();
      const overflow = rect.bottom > window.innerHeight;
      if (overflow) {
        subMenu.style.top = 'auto';
        subMenu.style.bottom = '25%';
        subMenu.style.boxShadow = '0px -15px 40px 0px rgba(82, 63, 105, 0.15)';
      } else {
        subMenu.style.top = '';
        subMenu.style.bottom = '';
        subMenu.style.boxShadow = '';
      }
    };

    const handleMouseLeave = (e) => {
      const subMenu = e.currentTarget.querySelector('.subMenu');
      if (!subMenu) return;
      subMenu.style.top = '';
      subMenu.style.bottom = '';
      subMenu.style.boxShadow = '';
    };

    // Sadece tanımlar menüsü için uygula
    const tanimlarMenu = document.querySelectorAll('.has-subMenu-left');
    tanimlarMenu.forEach((item) => {
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    });

    return () => {
      tanimlarMenu.forEach((item) => {
        item.removeEventListener('mouseenter', handleMouseEnter);
        item.removeEventListener('mouseleave', handleMouseLeave);
      });
    };
  }, []);

  return (
    <>
      {loading && (
        <SpinerCustomStyle>
          <Spin />
        </SpinerCustomStyle>
      )}
      <TopMenuStyle>
        <div className="ninjadash-top-menu">
          <ul>
            <Can
              perform={[
                MUHENDIS,
                FIRMA,
                SUBE_MUDURU,
                KAMU_MUHENDISI,
                KOMISYON_UYESI,
                KOMISYON_YEDEK_UYESI,
                UYGULAMA_YONETICISI,
                BAKANLIK_DAIRE_BASKANI,
                GENEL_MUDUR,
                GENEL_MUDUR_YARDIMCISI,
                IL_MUDURU,
                IL_MUDUR_YARDIMCISI,
              ]}
            >
              <li className="has-subMenu proje-subMenu">
                <Link to="#" className="parent">
                  {t('menu.proje')}
                </Link>
                <ul className="subMenu">
                  <Can perform={[UYGULAMA_YONETICISI]}>
                    <li>
                      <NavLink onClick={addParentActive} to={`${path}/proje/projelist/taslaklarim`}>
                        <UilFolder />
                        {t('menu.proje.taslaklarim')}
                      </NavLink>
                    </li>
                  </Can>

                  <Can perform={[UYGULAMA_YONETICISI, FIRMA]}>
                    <li>
                      <NavLink onClick={addParentActive} to={`${path}/pages/wizards/proje`}>
                        <UilFolderPlus />
                        {t('menu.proje.yeniProje')}
                      </NavLink>
                    </li>
                  </Can>

                  <Can
                    perform={[
                      MUHENDIS,
                      FIRMA,
                      SUBE_MUDURU,
                      KAMU_MUHENDISI,
                      KOMISYON_UYESI,
                      KOMISYON_YEDEK_UYESI,
                      UYGULAMA_YONETICISI,
                      BAKANLIK_DAIRE_BASKANI,
                      IL_MUDUR_YARDIMCISI,
                      IL_MUDURU,
                    ]}
                  >
                    <li>
                      <NavLink onClick={addParentActive} to={`${path}/proje/projelist/aktifProjelerim`}>
                        <UilFolderCheck />
                        {t('menu.proje.aktifProjelerim')}
                        {menuData &&
                          (() => {
                            const projeler = menuData.find(
                              (x) => x.projeTipId === YerbisConstants.ProjeListesiTipleri.AktifProjelerim,
                            );
                            if (!projeler) {
                              return '';
                            }

                            const { okunanProjeSayisi, projeSayisi } = projeler;

                            return okunanProjeSayisi === -1
                              ? ` (${projeSayisi ?? 0})`
                              : ` (${okunanProjeSayisi ?? 0} / ${projeSayisi ?? 0})`;
                          })()}
                      </NavLink>
                    </li>
                  </Can>

                  <Can
                    perform={[
                      MUHENDIS,
                      SUBE_MUDURU,
                      KAMU_MUHENDISI,
                      KOMISYON_UYESI,
                      KOMISYON_YEDEK_UYESI,
                      UYGULAMA_YONETICISI,
                      BAKANLIK_DAIRE_BASKANI,
                      GENEL_MUDUR,
                      GENEL_MUDUR_YARDIMCISI,
                      IL_MUDUR_YARDIMCISI,
                      IL_MUDURU,
                    ]}
                  >
                    <li>
                      <NavLink onClick={addParentActive} to={`${path}/proje/projelist/imzaBekleyen`}>
                        <UilFolderExclamation />
                        {t('menu.proje.imzaBekleyen')}
                        {menuData &&
                          (() => {
                            const projeler = menuData.find(
                              (x) => x.projeTipId === YerbisConstants.ProjeListesiTipleri.ImzaBekleyen,
                            );
                            if (!projeler) {
                              return '';
                            }

                            const { okunanProjeSayisi, projeSayisi } = projeler;

                            return okunanProjeSayisi === -1
                              ? ` (${projeSayisi ?? 0})`
                              : ` (${okunanProjeSayisi ?? 0} / ${projeSayisi ?? 0})`;
                          })()}
                      </NavLink>
                    </li>
                  </Can>

                  <Can
                    perform={[
                      MUHENDIS,
                      FIRMA,
                      SUBE_MUDURU,
                      KAMU_MUHENDISI,
                      KOMISYON_UYESI,
                      KOMISYON_YEDEK_UYESI,
                      UYGULAMA_YONETICISI,
                      BAKANLIK_DAIRE_BASKANI,
                      IL_MUDUR_YARDIMCISI,
                      IL_MUDURU,
                    ]}
                  >
                    <li>
                      <NavLink onClick={addParentActive} to={`${path}/proje/projelist/arsivProjelerim`}>
                        <UilFolderLock />
                        {t('menu.proje.arsivProjelerim')}
                      </NavLink>
                    </li>
                  </Can>

                  <Can
                    perform={[
                      SUBE_MUDURU,
                      UYGULAMA_YONETICISI,
                      BAKANLIK_DAIRE_BASKANI,
                      // GENEL_MUDUR,
                      // GENEL_MUDUR_YARDIMCISI,
                      IL_MUDUR_YARDIMCISI,
                      IL_MUDURU,
                    ]}
                  >
                    <li>
                      <NavLink onClick={addParentActive} to={`${path}/proje/projelist/tumProjeler`}>
                        <UilFolderInfo />
                        {t('menu.proje.tumProjeler')}
                        {menuData &&
                          (() => {
                            const projeler = menuData.find(
                              (x) => x.projeTipId === YerbisConstants.ProjeListesiTipleri.TumProjeler,
                            );
                            if (!projeler) {
                              return '';
                            }

                            const { okunanProjeSayisi, projeSayisi } = projeler;

                            return okunanProjeSayisi === -1
                              ? ` (${projeSayisi ?? 0})`
                              : ` (${okunanProjeSayisi ?? 0} / ${projeSayisi ?? 0})`;
                          })()}
                      </NavLink>
                    </li>
                  </Can>

                  <Can
                    perform={[
                      KOMISYON_UYESI,
                      KOMISYON_YEDEK_UYESI,
                      UYGULAMA_YONETICISI,
                      BAKANLIK_DAIRE_BASKANI,
                      SUBE_MUDURU,
                    ]}
                  >
                    <li>
                      <NavLink onClick={addParentActive} to={`${path}/proje/projelist/komisyonProjeleri`}>
                        <UilFolderExclamation />
                        {t('menu.proje.komisyonProjeleri')}
                        {menuData &&
                          (() => {
                            const projeler = menuData.find(
                              (x) => x.projeTipId === YerbisConstants.ProjeListesiTipleri.KomisyonProjeleri,
                            );
                            return projeler
                              ? ` (${projeler.okunanProjeSayisi ?? 0} / ${projeler.projeSayisi ?? 0})`
                              : ' (0 / 0)';
                          })()}
                      </NavLink>
                    </li>
                  </Can>

                  <Can perform={[SUBE_MUDURU, UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI]}>
                    {!hasRoles([SUBE_MUDURU]) || user.organizationId === YerbisConstants.NodeIds.Bakanlik ? (
                      <li>
                        <NavLink onClick={addParentActive} to={`${path}/proje/projelist/ildenGelenProjeler`}>
                          <UilFolderDownload />
                          {t('menu.proje.ildenGelenProjeler')}
                          {menuData &&
                            (() => {
                              const projeler = menuData.find(
                                (x) => x.projeTipId === YerbisConstants.ProjeListesiTipleri.IldenGelenProjeler,
                              );
                              return projeler
                                ? ` (${projeler.okunanProjeSayisi ?? 0} / ${projeler.projeSayisi ?? 0})`
                                : ' (0 / 0)';
                            })()}
                        </NavLink>
                      </li>
                    ) : (
                      ''
                    )}
                  </Can>

                  <Can perform={[UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI, SUBE_MUDURU, IL_SUBE_MUDURU]}>
                    <li>
                      <NavLink onClick={addParentActive} to={`${path}/proje/projelist/muhendisTalepleri`}>
                        <UilUserCheck />
                        {t('menu.proje.muhendisTalepleri')}
                        {menuData &&
                          (() => {
                            const projeler = menuData.find(
                              (x) => x.projeTipId === YerbisConstants.ProjeListesiTipleri.MuhendisTalepleri,
                            );
                            return projeler
                              ? ` (${projeler.okunanProjeSayisi ?? 0} / ${projeler.projeSayisi ?? 0})`
                              : ' (0 / 0)';
                          })()}
                      </NavLink>
                    </li>
                  </Can>

                  <Can
                    perform={[
                      SUBE_MUDURU,
                      KAMU_MUHENDISI,
                      KOMISYON_UYESI,
                      KOMISYON_YEDEK_UYESI,
                      UYGULAMA_YONETICISI,
                      BAKANLIK_DAIRE_BASKANI,
                      GENEL_MUDUR,
                      GENEL_MUDUR_YARDIMCISI,
                      IL_MUDUR_YARDIMCISI,
                      IL_MUDURU,
                    ]}
                  >
                    {' '}
                    <li className="has-subMenu-left">
                      <Link to="#" className="parent">
                        <UilFolderLock />
                        {t('menu.proje.bakanlikArsiv')}
                      </Link>
                      <ul className="subMenu">
                        <li>
                          <NavLink onClick={addParentActive} to={`${path}/proje/projelist/2018OncesiArsiv`}>
                            {t('menu.proje.2018OncesiArsiv')}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink onClick={addParentActive} to={`${path}/proje/projelist/2018SonrasiArsiv`}>
                            {t('menu.proje.2018SonrasiArsiv')}
                          </NavLink>
                        </li>
                      </ul>
                    </li>{' '}
                  </Can>

                  <Can perform={[UYGULAMA_YONETICISI]}>
                    {' '}
                    <li className="has-subMenu-left">
                      <Link to="#" className="parent">
                        <UilCommentAltEdit />
                        {t('menu.proje.projeIslemleri')}
                      </Link>
                      <ul className="subMenu">
                        <li>
                          <Link
                            to="#"
                            className="parent"
                            onClick={() => {
                              setProjeDurumDegistirVisible(true);
                            }}
                          >
                            {t('menu.yonetim.projeDurumDegistir')}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="parent"
                            onClick={() => {
                              setProjeYonetimiVisible(true);
                            }}
                          >
                            {t('menu.yonetim.projeYonetimi')}
                          </Link>
                        </li>
                        <li>
                          <NavLink onClick={addParentActive} to={`${path}/referansIslemleri`}>
                            {t('menu.yonetim.referansNoOlustur')}
                          </NavLink>
                        </li>
                      </ul>
                    </li>{' '}
                  </Can>

                  {/* <Can perform={[UYGULAMA_YONETICISI]}>
                    <li>
                      <Link
                        to="#"
                        className="parent"
                        onClick={() => {
                          setProjeDurumDegistirVisible(true);
                        }}
                      >
                        <UilRefresh />
                        {t('menu.yonetim.projeDurumDegistir')}
                      </Link>
                    </li>
                  </Can>

                  <Can perform={[UYGULAMA_YONETICISI]}>
                    <li>
                      <Link
                        to="#"
                        className="parent"
                        onClick={() => {
                          setProjeYonetimiVisible(true);
                        }}
                      >
                        <UilCommentAltEdit />
                        {t('menu.yonetim.projeYonetimi')}
                      </Link>
                    </li>
                  </Can>

                  <Can perform={[UYGULAMA_YONETICISI]}>
                    <li>
                      <Link
                        to="#"
                        className="parent"
                        onClick={() => {
                          setReferansNoOlusturVisible(true);
                        }}
                      >
                        <UilCommentAltEdit />
                        {t('menu.yonetim.referansNoOlustur')}
                      </Link>
                    </li>
                  </Can> */}

                  <Can perform={[SUBE_MUDURU, BAKANLIK_DAIRE_BASKANI, KAMU_MUHENDISI, UYGULAMA_YONETICISI]}>
                    <li className="has-subMenu-left">
                      <Link to="#" className="parent">
                        <UilCheckCircle />
                        {t('menu.tanimlar')}
                      </Link>
                      <ul className="subMenu open-up">
                        <li>
                          <NavLink onClick={addParentActive} to={`${path}/tanimlar/formasyon/`}>
                            {t('menu.tanimlar.formasyon')}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink onClick={addParentActive} to={`${path}/tanimlar/litoloji/`}>
                            {t('menu.tanimlar.litoloji')}
                          </NavLink>
                        </li>
                        <Can perform={[UYGULAMA_YONETICISI]}>
                          <li>
                            <NavLink onClick={addParentActive} to={`${path}/management/addupdate/cihazbilgileri`}>
                              {t('menu.yonetim.cihaz')}
                            </NavLink>
                          </li>
                        </Can>
                      </ul>
                    </li>{' '}
                  </Can>
                </ul>
              </li>
            </Can>

            {/* todo es burası düzenlenebilir */}
            {!bakanlikSubeMuduru && (
              <Can perform={[UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI, SUBE_MUDURU]}>
                <li className="has-subMenu">
                  <Link to="#" className="parent">
                    {t('menu.yonetim')}
                  </Link>
                  <ul className="subMenu">
                    <Can perform={[BAKANLIK_DAIRE_BASKANI, UYGULAMA_YONETICISI, SUBE_MUDURU]}>
                      <li>
                        <NavLink onClick={addParentActive} to={`${path}/kullanici/kurumkullanicilari/`}>
                          <UilUsersAlt />
                          {t('menu.yonetim.tumKullanicilar')}
                        </NavLink>
                      </li>
                    </Can>

                    <Can perform={[UYGULAMA_YONETICISI]}>
                      <li>
                        <Link to="#" className="parent" onClick={() => showModal()}>
                          <UilUserArrows />
                          {t('menu.yonetim.tayinİslemi')}
                        </Link>
                      </li>
                    </Can>

                    {user.organizationId === YerbisConstants.NodeIds.Bakanlik && (
                      <Can perform={[BAKANLIK_DAIRE_BASKANI, UYGULAMA_YONETICISI]}>
                        <li>
                          <NavLink onClick={addParentActive} to={`${path}/kullanici/anasayfa/`}>
                            <UilUsersAlt />
                            {t('menu.yonetim.kullanici')}
                          </NavLink>
                        </li>
                      </Can>
                    )}

                    <Can perform={[UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI]}>
                      <li>
                        <NavLink onClick={addParentActive} to={`${path}/kullanici/kullaniciGirisi`}>
                          <UilArrowFromRight />
                          {t('menu.yonetim.kullaniciGirisi')}
                        </NavLink>
                      </li>
                    </Can>

                    {user.organizationId === YerbisConstants.NodeIds.Bakanlik && (
                      <Can perform={[BAKANLIK_DAIRE_BASKANI, UYGULAMA_YONETICISI]}>
                        <li>
                          <NavLink onClick={addParentActive} to={`${path}/kurum/anasayfa/`}>
                            <UilBuilding />
                            {t('menu.yonetim.kurum')}
                          </NavLink>
                        </li>
                        <Can perform={[UYGULAMA_YONETICISI]}>
                          <li>
                            <NavLink onClick={addParentActive} to={`${path}/kullanici/kurumkullanicionay/`}>
                              <UilUserCheck />
                              {t('menu.yonetim.kurumKullaniciOnay')}
                            </NavLink>
                          </li>
                        </Can>
                        <li>
                          <NavLink onClick={addParentActive} to={`${path}/firma/anasayfa/`}>
                            <UilBriefcase />
                            {t('menu.yonetim.firma')}
                          </NavLink>
                        </li>
                      </Can>
                    )}

                    <Can perform={[UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI]}>
                      <li>
                        <NavLink onClick={addParentActive} to={`${path}/muhendis/anasayfa/`}>
                          <UilHardHat />
                          {t('menu.yonetim.muhendis')}
                        </NavLink>
                      </li>
                    </Can>

                    <Can perform={[UYGULAMA_YONETICISI]}>
                      <li>
                        <NavLink onClick={addParentActive} to={`${path}/haberlerveduyurular/anasayfa`}>
                          <UilMegaphone />
                          {t('menu.yonetim.haberlerDuyurular')}
                        </NavLink>
                      </li>
                    </Can>

                    <Can perform={[UYGULAMA_YONETICISI]}>
                      <li className="has-subMenu-left">
                        <Link to="#" className="parent">
                          <UilServerConnection />
                          {t('menu.yonetim.servis')}
                        </Link>
                        <ul className="subMenu open-up">
                          <li>
                            <NavLink onClick={addParentActive} to={`${path}/servisler/anasayfa`}>
                              <UilServerConnection />
                              {t('menu.yonetim.servisler')}
                            </NavLink>
                          </li>
                          <li>
                            <NavLink onClick={addParentActive} to={`${path}/servisler/servisLog`}>
                              <UilServerConnection />
                              {t('menu.yonetim.servisLog')}
                            </NavLink>
                          </li>
                        </ul>
                      </li>{' '}
                    </Can>
                  </ul>
                </li>
              </Can>
            )}

            <Can perform={[FIRMA]}>
              <li className="megaMenu-wrapper">
                <NavLink className="parent" onClick={addParentActive} to={`${path}/muhendisislemleri/muhendisler/`}>
                  {t('menu.muhendisBilgileri')}
                </NavLink>
              </li>
            </Can>

            <Can perform={[BAKANLIK_DAIRE_BASKANI]}>
              <li className="has-subMenu">
                <Link to="#" className="parent">
                  {t('menu.gorevlendirme')}
                </Link>
                <ul className="subMenu">
                  <li>
                    <NavLink onClick={addParentActive} to={`${path}/gorevlendirme/muhendisatamalari`}>
                      {t('menu.gorevlendirme.muhendisAtamalari')}
                      {menuData &&
                        (() => {
                          const projeler = menuData.find(
                            (x) => x.projeTipId === YerbisConstants.ProjeListesiTipleri.MuhendisAtamalari,
                          );
                          return projeler
                            ? ` (${projeler.okunanProjeSayisi ?? 0} / ${projeler.projeSayisi ?? 0})`
                            : ' (0 / 0)';
                        })()}
                    </NavLink>
                    <NavLink onClick={addParentActive} to={`${path}/gorevlendirme/ilmuhendistalepleri/`}>
                      {t('menu.gorevlendirme.ilMuhendisTalepleri')}
                      {menuData &&
                        (() => {
                          const projeler = menuData.find(
                            (x) => x.projeTipId === YerbisConstants.ProjeListesiTipleri.IlMuhendisAtamalari,
                          );
                          return projeler
                            ? ` (${projeler.okunanProjeSayisi ?? 0} / ${projeler.projeSayisi ?? 0})`
                            : ' (0 / 0)';
                        })()}
                    </NavLink>
                  </li>
                </ul>
              </li>
            </Can>

            <Can perform={[UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI, SUBE_MUDURU]}>
              {user.organizationId === YerbisConstants.NodeIds.Bakanlik && (
                <li>
                  <Link to="#" className="parent" onClick={fetchAndDownloadExcel}>
                    {t('personelProjeDurumu')}
                  </Link>
                </li>
              )}
            </Can>

            <Can perform={[UYGULAMA_YONETICISI, BAKANLIK_DAIRE_BASKANI, SUBE_MUDURU]}>
              {user.organizationId === YerbisConstants.NodeIds.Bakanlik && (
                <li className="megaMenu-wrapper">
                  <NavLink className="parent" onClick={addParentActive} to="/afetverianalizi">
                    {t('afetVeriAnaliz')}
                  </NavLink>
                </li>
              )}
            </Can>
          </ul>
        </div>
      </TopMenuStyle>
      {projeDurumDegistirVisible && (
        <ProjeDurumDegistir visible={projeDurumDegistirVisible} onCancel={() => setProjeDurumDegistirVisible(false)} />
      )}

      {projeYonetimiVisible && (
        <ProjeYonetimi visible={projeYonetimiVisible} onCancel={() => setProjeYonetimiVisible(false)} />
      )}

      {isModalVisible && <KullaniciTayinIslemi isModalVisible={isModalVisible} handleCancel={handleCancel} />}

      {referansNoOlusturVisible && (
        <ReferansNoOlustur
          isModalVisible={referansNoOlusturVisible}
          handleCancel={() => setReferansNoOlusturVisible(false)}
        />
      )}
    </>
  );
}

export default TopMenu;
